import { CourseDateSlotsType } from "@/app/types";
import BorderTopCard from "@/app/[locale]/components/cards/BorderTopCard";
import { useParams } from "next/navigation";
import React from "react";
import Link from "next/link";
import { useTranslations } from "next-intl";

const getCourseUrl = (courseId: string | string[], courseName?: string) => {
  const id = Array.isArray(courseId) ? courseId[0] : courseId;
  return courseName 
    ? courseName.toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '')
    : id;
};

function formatDateToMonthDay(dateString: string) {
  const date = new Date(dateString);
  return date.toLocaleDateString(undefined, {
    month: "long",
    day: "numeric",
  });
}

export type DateCardPropsType = {
  name: string;
  price: number | string;
  numberOfStudents: string;
  studentsInClass: string;
  dates: CourseDateSlotsType[];
  color?: string;
  textColor?: string;
  courseName?: string;
};

function DateCard({
  color,
  dates,
  name,
  studentsInClass,
  numberOfStudents,
  price,
  textColor = "#fff",
  courseName,
}: DateCardPropsType) {
  const t = useTranslations("courses.dates");
  const {courseId} = useParams();

  return (
    <BorderTopCard className="flex-1 " color={color}>
      <h2
        className="text-center lg:text-[2.5rem] text-[18px] font-bold"
        style={{ color: color }}
      >
        {name}
      </h2>
      <div
        className="flex lg:h-[6.25rem] lg:rounded-[10px] rounded-[5px] h-[50px]"
        style={{ background: `${color}20` }}
      >
        <div
          className="lg:rounded-[10px] rounded-[5px] text-white h-full flex flex-col items-center justify-center w-[33%]"
          style={{ background: color }}
        >
          <p className="text-[16px] lg:text-[2.5rem] font-bold">{price}€</p>
          <p className="text-[12px] lg:text-[1.25rem] font-medium">
            {t("weekly")}
          </p>
        </div>
        <div className="flex flex-col items-center justify-center flex-1">
          <p className="text-[16px] lg:text-[2.5rem] font-bold">
            {numberOfStudents}
          </p>
          <p className="text-[12px] lg:text-[1.25rem] font-medium">
            {studentsInClass}
          </p>
        </div>
      </div>
      <div className="flex flex-col  gap-8 lg:px-[1rem]">
        {dates?.map((date, index) => (
          <Link
            href={`/courses/${courseId}/enroll?solt=${date.id}`}
            key={index}
            className="flex w-full items-center cursor-pointer hover:bg-primary group hover:scale-x-[1.009]  origin-left  transition-all   ease-in-out duration-300 lg:px-[2.5rem] !pe-4 px-[18px] py-[9px] lg:py-[0.6rem] rounded-[25px] lg:rounded-[40px] bg-[#FAFAFA] "
          >
            <div className="flex-1 font-[600] flex flex-col group-hover:text-white transition-all   ease-in-out duration-300">
              <p className="lg:text-[1.75rem] text-[14px]">
                {date?.day}
                {/* , {date.startsOn} */}
              </p>
              {/* <p className="lg:text-[1.25rem] text-[12px]">
                {t("start")} {formatDateToMonthDay(date.fromDate)}
              </p> */}
            </div>
            <div>
              <div
                className="flex items-center text-[12px] lg:text-[1.25rem] text-white  bg-secondary rounded-full py-[10px] px-[21px] lg:px-[0.93rem] lg:py-[0.5rem]"
                style={{ background: color, color: textColor }}
              >
                {t("enroll")}
                <p className="hidden md:inline-block"> &nbsp; {t("now")}</p>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15.109"
                  height="8.377"
                  viewBox="0 0 15.109 8.377"
                  className={`
                  rotate-90 rtl:-rotate-90 w-[10px]  lg:w-[15px]`}
                >
                  <path
                    id="Path_49625"
                    data-name="Path 49625"
                    d="M-14235-22930l5.834,5.359,5.742-5.359"
                    transform="translate(-14221.657 -22923.391) rotate(180)"
                    fill="none"
                    stroke={textColor}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2.5"
                  />
                </svg>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </BorderTopCard>
  );
}

export default DateCard;